export default __webpack_public_path__ + "static/media/no-connection.c2945660.png";